// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reorder-all-button-wrapper[data-v-83ec04da]{position:absolute;right:24px}.product-name-link[data-v-83ec04da],.product-pn-link[data-v-83ec04da]{color:#0063a6;text-decoration:underline;cursor:pointer}.product-name-link[data-v-83ec04da]{text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
